import styled from "@emotion/styled";
import colors from "src/styles/variables.scss";

export const Layout = styled.div`
  background-color: ${colors.blackBackground};
  height: 100%;
  width: 100%;
  /* position: fixed; */
`;
export const Container = styled.div`
  display: grid;
  grid-template-columns: repeat(12, 1fr);
  grid-template-rows: repeat(12, 1fr);
  grid-gap: 1rem;
  width: 100%;
  height: 100%;
  margin: 0 auto;

  .notesTopSection {
    grid-row: 1 / 2;
    grid-column: 2/12;
    height: 100px;
    min-height: 100px;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    .notesHeader {
      color: rgb(255, 255, 255);
      height: 27px;
      width: 150px;
      font-size: 21px;
      font-weight: bold;
    }
    .navigationHome {
      color: rgb(50, 178, 255);
      text-decoration: "none";
      height: 18px;
      width: 36px;
      font-size: 13px;
      padding-top: 1%;
      margin-left: auto;
    }
  }

  .notesArea {
    background-color: ${colors.bluishGray};
    grid-column: 1 / 13;
    grid-row: 2/13;
  }
  .horzontalSeparator {
    margin-top: 3%;
    grid-column: 2 / 12;
    grid-row: 3 / 4;
    height: 1px;
    background-color: ${colors.autumnFog};
    opacity: 0.3;
  }

  .discountedHeadersGroup {
    width: 100%;
    grid-column: 2 / 5;
    grid-row: 2 / 3;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    padding-top: 30%;
    text-transform: uppercase;
    .dailyTotalDiscountedOrders {
      width: 188px;
      text-transform: upperCase;
      font-family: Arial, "sans-serif";
      font-size: 1.2rem;
      font-weight: bold;
      font-style: normal;
      font-stretch: normal;
      line-height: 1.33;
      letter-spacing: 0.3px;
      color: ${colors.milkyWhite};
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
    }

    .daily {
      width: 188px;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      opacity: 0.5;
      text-transform: upperCase;
      font-family: Arial, "sans-serif";
      font-size: 11px;
      font-weight: 500;
      font-style: normal;
      font-stretch: normal;
      line-height: normal;
      letter-spacing: normal;
      color: ${colors.milkyWhite};
    }
  }

  .inputBoxNotes {
    grid-column: 2/12;
    grid-row: 3/4;
    background-color: ${colors.gunpowderGray};
    padding: 2%;
    display: flex;
    margin-top: 10%;
    flex-direction: row;
    justify-content: space-between;
    height: 80px;
    .inputAreaNotes {
      /* width: 260px; */
      width: 90%;
      font-family: Arial, "sans-serif";
      font-size: 14px;
      font-weight: normal;
      font-style: normal;
      font-stretch: normal;
      line-height: normal;
      letter-spacing: normal;
      background-color: ${colors.gunpowderGray} !important;
      outline: none;
      color: ${colors.milkyWhite};
      border: none;
      opacity: 1 !important;
    }
    textarea::placeholder {
      padding: 0 2%;
      color: ${colors.milkyWhite};
      opacity: 0.5;
    }
    .textLength {
      margin-top: auto;
      margin-left: 2%;
      height: 16px;
      font-family: Arial, "sans-serif";
      font-size: 12px;
      font-weight: normal;
      font-style: normal;
      font-stretch: normal;
      line-height: 2;
      letter-spacing: normal;
      color: ${colors.milkyWhite};
    }
  }
  .ShimmerGroup {
    margin-top: 10%;
    height: 100%;
    grid-column: 7 / 12;
    grid-row: 2 / 2;
    display: flex;
    flex-direction: column;
    justify-content: space-evenly;
    align-items: flex-end;
    padding-left: 10%;
    margin-bottom: 5%;
  }
  .progressGroup404 {
    grid-column: 9 / 12;
    grid-row: 2 / 3;
    margin-top: 30%;
  }
  .progressGroup {
    grid-column: 7 / 12;
    padding-top: 10%;
    grid-row: 2 / 3;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    margin-left: auto;
    margin-bottom: auto;

    .discountedOrderNumber {
      margin-left: auto;
      margin-bottom: auto;
      font-family: Arial, "sans-serif";
      font-size: 24px;
      font-weight: bold;
      font-style: normal;
      font-stretch: normal;
      line-height: normal;
      letter-spacing: 0.4px;
      color: ${colors.milkyWhite};
    }
    .percentageGroup {
      display: flex;
      flex-direction: row;
      justify-content: flex-start;
      margin-left: auto;
      margin-bottom: 1%;
      .chart-progress-up {
        padding-top: 6%;
        font-family: Arial, "sans-serif";
        font-size: 8px;
        font-weight: normal;
        font-style: normal;
        font-stretch: normal;
        line-height: normal;
        letter-spacing: 0.3px;
        color: ${colors.vibrantGreen};
        margin-right: 4px;
      }
      .chart-progress-down {
        padding-top: 6%;
        font-family: Arial, "sans-serif";
        font-size: 8px;
        font-weight: normal;
        font-style: normal;
        font-stretch: normal;
        line-height: normal;
        letter-spacing: 0.3px;
        margin-right: 4px;
        color: rgb(238, 88, 73);
      }
      .wowPercentage-up {
        font-family: Arial, "sans-serif";
        font-size: 12px;
        font-weight: normal;
        font-style: normal;
        font-stretch: normal;
        line-height: normal;
        letter-spacing: 0.4px;
        text-align: right;
        color: ${colors.upGreen};
      }
      .wowPercentage-down {
        font-family: Arial, "sans-serif";
        font-size: 12px;
        font-weight: normal;
        font-style: normal;
        font-stretch: normal;
        line-height: normal;
        letter-spacing: 0.4px;
        text-align: right;
        color: rgb(238, 88, 73);
      }
      .wowPercentage-neutral {
        content: "- -";
        font-family: Arial, "sans-serif";
        font-size: 12px;
        font-weight: normal;
        font-style: normal;
        font-stretch: normal;
        line-height: normal;
        letter-spacing: 0.4px;
        text-align: right;
        color: white;
      }
    }
  }

  .actionGroup {
    grid-column: 6 / 12;
    grid-row: 4 / 5;
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    margin-left: auto;
    transition: visibility 0.5s linear;
    .cancel,
    .submit {
      width: 82px;
      height: 24px;
      border-radius: 4px;
      display: flex;
      align-items: center;
      justify-content: center;
    }
    .submit {
      margin-left: 5%;
    }
  }

  .previousNotes {
    grid-column: 2 / 6;
    grid-row: 5 / 5;
    opacity: 0.75;
    font-family: Arial, "sans-serif";
    font-size: 12px;
    font-weight: normal;
    font-style: normal;
    font-stretch: normal;
    line-height: normal;
    letter-spacing: 0.7px;
    color: ${colors.milkyWhite};
  }
  .notesList {
    grid-column: 2 / 12;
    grid-row: 5/13;
    margin-top: 10%;
    overflow-y: auto;
    overflow-x: hidden;

    padding: 0;
    list-style-type: none;
    position: relative;
    padding-bottom: 20px;
    .noteRow {
      margin-top: 6%;
      transition: 0.2s transform;
      &.no-transition {
        -webkit-transition: none;
        -moz-transition: none;
        -o-transition: color 0 ease-in;
        -ms-transition: none;
        transition: none;
      }

      .parallelRow {
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        .row {
          display: flex;
          flex-direction: row;
          justify-content: space-between;
          .cross {
            width: 12.6px;
            height: 12.6px;
            display: flex;
            align-items: center;
            justify-content: center;
            padding: 10px;
          }
          .slider {
            width: 13.4px;
            height: 13.7px;
            display: flex;
            align-items: center;
            justify-content: center;
            padding: 10px;
          }
          .noteData {
            display: flex;
            flex-direction: column;
            justify-content: flex-start;
            padding: 0 5%;
            width: 260px;
            min-height: auto;
            .noteTitle {
              width: auto;
              word-wrap: break-word;
              font-family: Arial, "sans-serif";
              font-size: 12px;
              font-weight: normal;
              font-style: normal;
              font-stretch: normal;
              line-height: 1.33;
              letter-spacing: 0.3px;
              color: ${colors.milkyWhite};
            }
            .noteTimestamp {
              margin-top: 2%;
              width: 121px;
              height: 15px;
              opacity: 0.5;
              font-family: Arial, "sans-serif";
              font-size: 12px;
              font-weight: 500;
              font-style: normal;
              font-stretch: normal;
              line-height: normal;
              letter-spacing: normal;
              color: ${colors.milkyWhite};
            }
          }
        }
        .eachNoteSeparator {
          margin-top: 6%;
          height: 1.5px;
          background-color: ${colors.autumnFog};
          opacity: 0.3;
        }
      }
    }
  }
`;
